import { render, staticRenderFns } from "./DashboardClientScope.vue?vue&type=template&id=6fd2c995&"
import script from "./DashboardClientScope.vue?vue&type=script&lang=ts&"
export * from "./DashboardClientScope.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fd2c995')) {
      api.createRecord('6fd2c995', component.options)
    } else {
      api.reload('6fd2c995', component.options)
    }
    module.hot.accept("./DashboardClientScope.vue?vue&type=template&id=6fd2c995&", function () {
      api.rerender('6fd2c995', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/clientDashboard/DashboardClientScope.vue"
export default component.exports